import { shallowRef, watch } from "vue";
import { i18n } from "../i18n/i18n";
import { appLanguageSwitcherModel } from "@/shared/components/app-language-switcher/app-language-switcher.model";
import { getEnvValue } from "./environment";

export const pageTitle = shallowRef<string | undefined>();
const brandLabel = getEnvValue("BRAND_LABEL");
export const BRAND_NAMES = {
    carconnex: "CARCONNEX",
    astara: "ASTARA",
};
watch(
    () => ({
        titleTranslateKey: pageTitle.value,
        lang: appLanguageSwitcherModel?.lang.value,
    }),
    ({ titleTranslateKey }) => {
        document.title = titleTranslateKey
            ? i18n.global.t(titleTranslateKey, { brandName: BRAND_NAMES[brandLabel] })
            : BRAND_NAMES[brandLabel];
    },
    { immediate: true },
);
